import type { PropsWithChildren } from 'react';

import { type IBaseTextProps } from './BaseText'
import { SubTextStyled } from './styles/SubTextStyled'

export const SubText = (props: PropsWithChildren<IBaseTextProps>) => (
  <SubTextStyled {...props} />
)

SubText.displayName = 'SubText'
